import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { getVendorData } from "../../AddDetails/Vendor/Vendor.action";
import { IssuanceReportApi } from "./ProductionIssuanceAction";
import { GetOrderCreationApi } from "../orderCreation/OrderCreationAction";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import MaterialSize from "material-table";
// import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import moment from "moment";
import jsPDF from "jspdf";


const IssuanceFilter = (props) => {
    const [vendorId, setVendorId] = useState();
    const [vendorName, setVendorName] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [orderId, setOrderId] = useState();
    const [orderSeqId, setOrderSeqId] = useState();
    const [show, setShow] = useState(false);

    const handleChangeVendor = (selectedOption) => {
        setVendorId(selectedOption.value);
        setVendorName(selectedOption.label);
    };
    const GetVendorList = !_.isEmpty(props.vendorDataList) && props.vendorDataList.map((x) => {
        let data = { value: x._id, label: x.vendorName };
        return data;
    });

    const handleChangeOrder = (selectedOption) => {
        setOrderId(selectedOption.value);
        setOrderSeqId(selectedOption.label)
    };
    const GetOrderList = !_.isEmpty(props.orderCreationList) && props.orderCreationList.map((x) => {
        let data = { value: x._id, label: `${x.sequenceNumber}` };
        return data;
    });

    useEffect(() => {
        props.getVendorData();
        props.GetOrderCreationApi();
        props.setHeading("Issuance Report");
    }, []);

    function SearchData() {
        props.IssuanceReportApi({
            vendorId: vendorId,
            orderId: orderId,
            startDate: startDate,
            endDate: endDate,
        });
        setShow(true);
    }

    return (
        <>
            {props.isFetchingVendor || props.isFetchingOrderCreation ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Order </b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(GetOrderList)}
                                    placeholder="Select Order"
                                    onChange={handleChangeOrder}
                                    options={GetOrderList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>Start Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Start Date"
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>End Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="End Date"
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Vendor</b></Form.Label>
                                <Select
                                    placeholder="Select Vendor"
                                    onChange={handleChangeVendor}
                                    options={GetVendorList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SearchData}> SEARCH </Button>
                    </div>


                    <div>
                        {show &&
                            <MaterialSize
                                title="Issuance Report"
                                columns={[
                                    { title: 'Order No#', field: 'orderNumber' },
                                    { title: 'Issuance No#', field: 'sequenceNumber' },
                                    { title: 'Vendor Name', field: 'vendorName' },
                                    { title: 'Issuance Date', field: 'issuanceDate' },
                                    { title: 'Article Name', field: 'articleName' },
                                    { title: 'Process Name', field: 'processName' },
                                    { title: 'Issuance Quantity', field: 'issuanceQuantity' },
                                    { title: 'Process Rate', field: 'processRate' },
                                    {
                                        title: "Total",
                                        render: (rowData) => (
                                            Number(rowData.issuanceQuantity) * Number(rowData.processRate)
                                        ),
                                    },
                                    { title: 'Return Date', field: 'returnDate' },
                                    // { title: 'Order Date', field: 'orderDate' },
                                    // { title: 'Order Quantity', field: 'orderQuantity' },
                                ]}
                                data={props.productionIssuanceReport.data}
                                options={{
                                    actionsColumnIndex: -1,
                                    exportButton: true,
                                    exportAllData: true,
                                    paging: true,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        onRowAdd: "none",
                                    },
                                    exportPdf: (columns, data) => {
                                        const orientation = "landscape";
                                        const doc = new jsPDF(orientation);

                                        const columnTitles = [
                                            "Order No",
                                            "Issuance No",
                                            "Vendor Name",
                                            "Issuance Date",
                                            "Article Name",
                                            "Process Name",
                                            "Issuance Quantity",
                                            "Process Rate",
                                            "Total",
                                            "Return Date"
                                        ];

                                        // Calculate Totals
                                        let totalIssuanceQuantity = data.reduce((sum, row) => sum + Number(row.issuanceQuantity), 0);
                                        let totalProcessRate = data.reduce((sum, row) => sum + Number(row.processRate), 0);
                                        let totalAmount = data.reduce((sum, row) => sum + (Number(row.issuanceQuantity) * Number(row.processRate)), 0);

                                        const pdfData = data.map((rowData) => [
                                            rowData.orderNumber,
                                            rowData.sequenceNumber,
                                            rowData.vendorName,
                                            rowData.issuanceDate,
                                            rowData.articleName,
                                            rowData.processName,
                                            rowData.issuanceQuantity,
                                            rowData.processRate,
                                            Number(rowData.issuanceQuantity) * Number(rowData.processRate),
                                            rowData.returnDate,
                                        ]);

                                        // Add totals row
                                        pdfData.push([
                                            "Total", "", "", "", "", "",
                                            totalIssuanceQuantity,
                                            totalProcessRate,
                                            totalAmount,
                                            "" // Empty column for return date
                                        ]);

                                        let content = {
                                            startY: 70,
                                            startX: 10,
                                            head: [columnTitles],
                                            body: pdfData,
                                            styles: { fontSize: 10 },
                                            headStyles: { fillColor: "#2980ba" },
                                            footStyles: { fontStyle: "bold" }
                                        };

                                        // doc.addImage(logo, "PNG", 15, 9, 28, 28);
                                        doc.setFontSize(12);
                                        doc.setFont("times", "normal");
                                        doc.setFont(undefined, "bold");
                                        doc.text(process.env.REACT_APP_COMPANY_NAME, 50, 18);
                                        doc.setFont("times", "normal");
                                        doc.text(process.env.REACT_APP_COMPANY_ADDRESS, 50, 25);
                                        doc.text(process.env.REACT_APP_COMPANY_NTN, 50, 32);
                                        doc.text(`Issuance Report`, 90, 40);
                                        doc.text(`Order Number: ${_.isUndefined(orderSeqId) ? '' : orderSeqId}`, 15, 50);
                                        doc.text(`Start Date: ${_.isUndefined(startDate) ? '' : startDate}`, 15, 55);
                                        doc.text(`End Date: ${_.isUndefined(endDate) ? '' : endDate}`, 15, 60);
                                        doc.text(`Vendor Name: ${_.isUndefined(vendorName) ? '' : vendorName}`, 15, 65);

                                        doc.autoTable(content);

                                        doc.setProperties({ title: `Issuance Report ${moment().format('YYYY-MM-DD')}` });

                                        var blob = doc.output("blob");
                                        window.open(URL.createObjectURL(blob));
                                    }
                                }}
                            />
                        }
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        IssuanceReportApi: (data) => dispatch(IssuanceReportApi(data)),
        getVendorData: () => dispatch(getVendorData()),
        setHeading: (data) => dispatch(setHeading(data)),
        GetOrderCreationApi: () => dispatch(GetOrderCreationApi()),
    };
};

const mapStateToProps = (state, ownProps) => ({
    vendorDataList: state.VendorReducer.vendorDataList,
    isFetchingVendor: state.VendorReducer.isFetchingVendor,
    productionIssuanceReport: state.ProductionIssuanceReducer.productionIssuanceReport,
    isFetchingOrderCreation: state.OrderCreationReducer.isFetchingOrderCreation,
    orderCreationList: state.OrderCreationReducer.orderCreationList,
});

export default connect(mapStateToProps, mapDispatchToProps)(IssuanceFilter);
